import React, { useMemo } from 'react';
import EditableTable, { TColumn, ColumnType } from '../../../../EditableTable';

import { IAttributesForm } from './AttributesForm';
import { sortAlphabetically } from '../../../../../helpers/comparators';
import TranslationHelper from '../../../../../helpers/TranslationHelper';
import { FormikErrors } from 'formik';

interface IOwnProps {
    values: IAttributesForm;
    setFieldValue: (name: string, value: any) => void;
    errors: FormikErrors<IAttributesForm>;
}

export const ObjectsTable = ({ values, errors, setFieldValue }: IOwnProps) => {
    const columns: TColumn[] = [
        {
            id: 'selected',
            label: '',
            type: ColumnType.CHECKBOX,
        },
        {
            id: 'name',
            label: 'Object name',
            type: ColumnType.TEXT,
        },
        {
            id: 'multipleValue',
            label: 'Multiple values',
            type: ColumnType.CHECKBOX,
        },
        {
            id: 'required',
            label: 'Required',
            type: ColumnType.CHECKBOX,
        },
    ];
    const onDataChange = (data: any) => {
        setFieldValue('connectedTo', data);
    };

    const data = useMemo(() => {
        return values.connectedTo
            .map((item) => {
                return { ...item, disabled: item.internal };
            })
            .sort((a, b) =>
                sortAlphabetically(
                    TranslationHelper.translate(a.name),
                    TranslationHelper.translate(b.name)
                )
            );
    }, [values.connectedTo]);
    return (
        <EditableTable
            columns={columns}
            data={data}
            errors={errors.connectedTo}
            onDataChange={onDataChange}
        />
    );
};
